import './index.css';
import "@aws-amplify/ui-react/styles.css";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Livisibly Design System — fonts & tokens
import '@fontsource/source-serif-4/300.css';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/500.css';
import '@fontsource/source-serif-4/600.css';
import '@fontsource/source-serif-4/700.css';
import '@fontsource/dm-sans/300.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import './design-system/tokens/index.css';
import React from 'react';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Authenticator } from "@aws-amplify/ui-react";
import CustomSignIn from './components/auth/CustomSignIn';
// import { ApiGatewayProvider } from "./components/ui/apigatewaycontext";
import { Amplify } from 'aws-amplify';
import { awsconfig } from "./aws-exports"
import { I18n } from '@aws-amplify/core';
import { translations } from '@aws-amplify/ui-react';

console.log("AWS Config", awsconfig)

Amplify.configure(awsconfig);
I18n.putVocabularies(translations);
I18n.putVocabularies({
  en: {
    'Confirm TOTP Code': 'Please enter your code from the authenticator app',
    'Setup TOTP': 'Scan the QR code with your authenticator app and enter the code from the app below',
    'Account recovery requires verified contact information': 'Please verify your email, we will send you a code to verify your account',
  },
});

// Custom Header Component with Logo
const CustomHeader = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      borderBottom: '1px solid #e9ecef'
    }}>
      <img
        src="/Livisibly - Full Logo (vector file).svg"
        alt="Livisibly Logo"
        style={{
          height: '300px',
          width: 'auto'
        }}
      />
    </div>
  );
};

// Custom Footer Component with Copyright
const CustomFooter = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      borderTop: '1px solid #e9ecef',
      fontSize: '14px',
      color: '#6c757d'
    }}>
      <p style={{ margin: 0 }}>
        © {new Date().getFullYear()} Livisibly LLC. All rights reserved.
      </p>
    </div>
  );
};

// Custom ConfirmSignIn component for TOTP
const CustomConfirmSignIn = ({ className, ...props }) => {
  return (
    <div className={className} style={{ textAlign: 'center', padding: '20px' }}>
      <h2 style={{
        fontSize: '24px',
        fontWeight: '500',
        marginBottom: '10px',
        color: '#333'
      }}>
        Enter Verification Code
      </h2>
      <p style={{
        fontSize: '14px',
        color: '#666',
        marginBottom: '20px',
        lineHeight: '1.5'
      }}>
        Open your authenticator app and enter the 6-digit verification code
      </p>
      <div {...props} />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// const formFields = {
//   setupTotp: {
//     QR: {
//       totpIssuer: 'Livisibly',
//     },
//   },
//   confirmSignIn: {
//     confirmation_code: {
//       placeholder: 'Enter 6-digit code',
//       label: 'Verification Code',
//       isRequired: true,
//     },
//   },
// };
const formFields = {
  signUp: {
    given_name: {
      label: 'First Name',
      placeholder: 'Enter your first name',
      isRequired: true,
      order: 1,
    },
    family_name: {
      label: 'Last Name',
      placeholder: 'Enter your last name',
      isRequired: true,
      order: 2,
    },
    email: {
      order: 3,
    },
    password: {
      order: 4,
    },
    confirm_password: {
      order: 5,
    },
  },
  setupTotp: {
    QR: {
      totpIssuer: 'Livisibly',
    },
  },
  confirmSignIn: {
    confirmation_code: {
      placeholder: 'Enter 6-digit code',
      label: 'Verification Code',
      isRequired: true,
    },
  },
};

// This will tell you if you're using development or production mode
console.log('React Build Mode:', process.env.NODE_ENV);

// Also check if development features are available
if (typeof React.StrictMode === 'undefined') {
  console.log('Using production build of React (StrictMode not available)');
} else {
  console.log('Using development build of React (StrictMode available)');
}

root.render(
  <React.StrictMode>
    <Authenticator
      signUpAttributes={['given_name', 'family_name']}
      formFields={formFields}
      // Custom SignIn (Trello Ea93pH0C): password uses the reliable client-based flow
      // (the machine's own submitForm -> USER_SRP_AUTH -> TOTP screen); passkey is a
      // dedicated button that calls signIn(USER_AUTH/WEB_AUTHN) with its own error
      // handling (no loop). The Amplify `passwordless` prop/config is intentionally NOT
      // set — advertising passwordless forces choice-based auth on password too, which
      // produced the two-step + loops. See frontend/src/components/auth/CustomSignIn.js.
      components={{
        Header: CustomHeader,
        Footer: CustomFooter,
        SignIn: {
          Footer: CustomSignIn
        },
        ConfirmSignIn: CustomConfirmSignIn
      }}
    >
      {/* <ApiGatewayProvider> */}
        <App />
      {/* </ApiGatewayProvider> */}
    </Authenticator>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);